/* global showSuccessToast */
/* global showInfoToast */

import React, { useState, useEffect, useCallback } from "react";
import { getStatusHistory, addStatusHistory } from "../../api/api";

const OUTCOME_COLORS = ["", "#28a745", "#ffc107", "#fd7e14", "#dc3545", "#dc3545"];
const OUTCOME_BUTTONS = [
    { value: "5", label: "KO AMMINISTRATIVO", className: "bg-danger" },
    { value: "4", label: "KO TECNICO", className: "bg-danger" },
    { value: "3", label: "ANNULLATO", className: "bg-warning" },
    { value: "2", label: "RICHIEDE ATTENZIONE", className: "bg-yellow" },
    { value: "1", label: "ATTIVO", className: "bg-success" },
];

const StatusHistoryModal = ({ companyID, selectedTargetItem, onSaved, users }) => {
    const [formDate, setFormDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [formNotes, setFormNotes] = useState("");
    const [formRatio, setFormRatio] = useState("");
    const [formUser, setFormUser] = useState("");
    const [statusHistory, setStatusHistory] = useState([]);

    const loadStatusHistory = useCallback(async (selectedTargetItem) => {
        const response = await getStatusHistory(selectedTargetItem.id);
        const history = response.data?.data?.getTargetStatusListing?.edges || [];
        setStatusHistory(history);
        return history;
    }, []);

    useEffect(() => {
        if (selectedTargetItem) {
            setStatusHistory([]);
            loadStatusHistory(selectedTargetItem);
        }
    }, [selectedTargetItem, loadStatusHistory]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const plainData = Object.fromEntries(new FormData(e.target).entries());
        await addStatusHistory(plainData);
        onSaved?.({ ...selectedTargetItem, status: Number(plainData.outcome) });
        showSuccessToast("Ricontatto aggiunto con successo!");
        setFormNotes("");
        setFormRatio("");
        setFormUser("");
        setFormDate(new Date().toISOString().slice(0, 10));
        loadStatusHistory(selectedTargetItem);
    };

    const phone = selectedTargetItem?.Contact[0]?.phone || "";

    return (
        <div>
            <form className="row" method="post" onSubmit={handleSubmit}>
                <input type="hidden" name="TargetItem" value={selectedTargetItem ? selectedTargetItem.id : ""} />
                <div className="form-group col-sm-4 col-12">
                    <label htmlFor="status-event-date">Data check</label>
                    <input
                        type="date"
                        className="form-control"
                        id="status-event-date"
                        name="date"
                        value={formDate}
                        onChange={e => setFormDate(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group col-sm-4 col-12">
                    <label htmlFor="status-event-ratio">Utente</label>
                    <select className="form-control" name="User" required value={formUser} onChange={e => setFormUser(e.target.value)}>
                        <option value=""></option>
                        {users.map((user, index) => (
                            <option key={index} value={user.node.id}>{user.node.username}</option>
                        ))}
                    </select>
                </div>
                <div className="form-group col-sm-4 col-12">
                    <label htmlFor="status-event-ratio">Stato</label>
                    <select
                        className="form-control"
                        id="status-event-ratio"
                        name="outcome"
                        value={formRatio}
                        onChange={e => setFormRatio(e.target.value)}
                        required
                    >
                        <option value=""></option>
                        <option value="1">Attivo</option>
                        <option value="2">Richiede attenzione</option>
                        <option value="3">Annullato</option>
                        <option value="4">KO Tecnico</option>
                        <option value="5">KO Amministrativo</option>
                    </select>
                </div>
                <div className="form-group col-12">
                    <div className="d-flex text-center">
                        {OUTCOME_BUTTONS.map(button => (
                            <a
                                key={button.value}
                                href="#"
                                onClick={e => { e.preventDefault(); setFormRatio(button.value); }}
                                className={`d-flex align-items-center justify-content-center p-1 ${button.className}`}
                                style={{ flex: "1 1 0", minWidth: 0 }}
                            >
                                <span className="text-white font-weight-bold" style={{ fontSize: "clamp(8px, 1.1vw, 12px)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{button.label}</span>
                            </a>
                        ))}
                    </div>
                </div>
                <div className="form-group col-12">
                    <label htmlFor="status-event-notes">Note/Messaggio</label>
                    <textarea
                        className="form-control"
                        id="status-event-notes"
                        name="note"
                        rows={5}
                        value={formNotes}
                        onChange={e => setFormNotes(e.target.value)}
                        placeholder="Aggiungi una nota dettagliata..."
                        required
                    />
                </div>
                {/* <div className="form-group col-6">
                    <a href={selectedTargetItem ? "tel:+39" + phone : ""} onClick={() => showInfoToast("Procedi su Collegamento telefono!")}>
                        <button type="button" className="btn btn-secondary btn-block col">Chiama</button>
                    </a>
                </div>
                <div className="form-group col-6">
                    <a href={selectedTargetItem ? "whatsapp://send?phone=39" + phone + "&text=" + encodeURIComponent(formNotes) : ""} target="_blank" rel="noreferrer" onClick={() => showInfoToast("Procedi su WhatsApp!")}>
                        <button type="button" className="btn btn-secondary btn-block col">Invia messaggio</button>
                    </a>
                </div> */}
                <div className="form-group col-12">
                    <button type="submit" className="btn btn-primary btn-block col">Aggiorna stato</button>
                </div>
            </form>
            <div className="d-flex flex-column gap-2" style={{ maxHeight: "300px", overflowY: "auto", paddingTop: "10px" }}>
                {selectedTargetItem && statusHistory.length > 0 ? (
                    statusHistory.map((edge, idx) => {
                        const event = edge.node;
                        return (
                            <div key={idx} className="card mb-2 shadow-sm" style={{ borderLeft: `5px solid ${OUTCOME_COLORS[event.outcome] || "#ccc"}` }}>
                                <div className="card-body p-2">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <div>
                                            <strong className="mr-2">{event.date ? new Date(event.date).toLocaleDateString("it-IT") : ""}</strong>
                                            <br />
                                            <i>{event.note}</i>
                                        </div>
                                        <span className="text-muted" style={{ fontSize: 13 }}>
                                            {event.User ? event.User[0].username : "Utente sconosciuto"}
                                        </span>
                                    </div>
                                    <div>
                                        <span className="d-block">{event.description}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center text-muted py-4">Nessun aggiornamento di stato.</div>
                )}
            </div>
        </div>
    );
};

export default StatusHistoryModal;